import CouponsOverview from '@/models/storePanel/redeem/CouponsOverview';
import moment from 'moment';
const getDefaultState = () => ({
  coupons: [],
  redeemedCouponAndVoucherCodesData: [],
  itemsLength: 0,
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setItems(state, payload) {
      state.coupons = payload.map((c) => {
        c.created_at = moment(c.created_at).format('DD/MM/YYYY HH:mm');
        if (c.available === null) c.available = 'Unlimited';
        return c;
      });
    },

    setRedeemedCouponAndVoucherCodes(state, payload) {
      state.redeemedCouponAndVoucherCodesData = payload;
    },

    setItemsLength(state, payload) {
      state.itemsLength = payload;
    },
  },

  actions: {
    async getItems({ commit }, query) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await CouponsOverview.get(query);

        const { data: coupons, pagination } = data.data.redeemed_coupons;

        commit('setItems', coupons);
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });
        commit('setServerPagination', pagination, {
          root: true,
        });
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response.data.message);
      }
    },

    async getRedeemedCouponAndVoucherCodes({ commit }, body) {
      try {
        commit('setLoading', true, { root: true });

        let query = `?page=${body.page}`;
        if (body.search) {
          query += `&q=${body.search}`;
        }
        if (body.order) {
          query += `&order=${body.order}`;
        }

        const { data } = await CouponsOverview.getRedeemedCouponAndVoucherCodes(
          body.coupon_id,
          query
        );

        const { redeemed_coupons_information, pagination } = data.data;

        commit('setRedeemedCouponAndVoucherCodes', redeemed_coupons_information);
        commit('setItemsLength', pagination.total);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response.data.message);
      }
    },
  },
};
